import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Steps, Row, Col } from 'antd';

import EmptyData from '@/components/EmptyData';
import { selectors } from '@/redux/tour/trip/create/model';

import GeneralDetails from './GeneralDetails';
import InclusionsExclusions from './InclusionsExclusions';
import Itenerary from './Itenerary';

const AddTourSteps = ({ step }) => {
    const { t } = useTranslation();

    const generalInfo = useSelector(selectors.generalInfo);
    const iteneraryData = useSelector(selectors.itenerary);
    const inclusions = useSelector(selectors.inclusions);
    const exclusions = useSelector(selectors.exclusions);

    return (
        <>
            <Steps
                className="steps-container"
                current={step}
                labelPlacement="vertical"
                items={[

                    { title: t('General Details') },
                    { title: t('Itenerary') },
                    { title: t('Incl. / Excl.') },
                ]}
            />

            <div className="data-display">
                {(generalInfo !== null)
                    ? (
                        <Row gutter={[0, 30]}>
                            <Col xs={24}>
                                <GeneralDetails data={generalInfo} />
                            </Col>
                            <Col xs={24}>
                                <Itenerary data={iteneraryData} />
                            </Col>
                            <Col xs={24}>
                                <InclusionsExclusions
                                    inclusions={inclusions}
                                    exclusions={exclusions}
                                />
                            </Col>
                        </Row>
                    )
                    : (<EmptyData />)}
            </div>
        </>
    );
};

export default AddTourSteps;
